<script>
    export let obj = false;
</script>

{#if !obj}
    <div class="has-text-centered">
        <span class="icon is-large has-text-info">
            <i class="fas fa-spinner fa-pulse fa-3x"></i>
        </span>
    </div>
{:else}
    <slot />
{/if}
